import { styled } from '@ublend-npm/aulaui-core';

export const AulaEditorWrapper = styled('div')(({ readOnly, theme }) => ({
  opacity: readOnly ? 0.5 : 1,

  // Code block line numbers
  '& code > div > span:first-child': {
    boxSizing: 'content-box',
    paddingInlineEnd: theme.spacing(1),
  },

  // '+' icon
  '& [data-testid="block-menu"]': {
    paddingLeft: theme.spacing(1),
  },

  // LaTeX Box
  '& [data-slate-node="element"]': {
    '& .katex-display': {
      maxWidth: '50rem !important',
    },
  },

  '& [data-testid="latex-syntax"]': {
    overflow: 'auto',
  },
}));
